<app-masterview [ismainadmin]="true" [navItems]="getNavItems()" (onNavSelected)="onNavSelected($event)">
    <div position="content">
        <router-outlet></router-outlet>
    </div>
</app-masterview>